import { createContext, useContext } from "react";
import { UniQuestion } from "../../dao/UniQuestion";
import { new_ErrorAlert } from "../../export_spwk/ExportManager";
import { SpwkMetaData_DataType } from "../../export_spwk/SpwkMetaData";
import { UiMeta } from "./UiMeta";
import { Member } from "../../dao/Member";

export type UiMetaTableContextProps = {
  _UiMetaTable: UiMetaTable | undefined;

  /** 一般問卷首次載入時的答案 */
  OriRhfData?: any;

  member: Member | undefined;
}

export const UiMetaTableContext = createContext<null | UiMetaTableContextProps>(null);

export function useUiMetaTable(): UiMetaTableContextProps | null {
  const re = useContext(UiMetaTableContext);

  return re;
}


export class UiMetaTable {



  meta_rows: UiMeta[] = [];

  ConcatMetaList(meta_list: UiMeta[]) {
    this.meta_rows = this.meta_rows.concat(meta_list);
  }
  /**
   * 多選，被拆分在不同題目的情況也是有可能的
   */
  FilterMetas_ByRhfName(rhf_name: string) {
    const rslt = this.meta_rows.filter(x => x.rhf_name === rhf_name);
    return rslt;
  }

  static ConvertQuestionToMetaList(questions: UniQuestion[]): UiMeta[] {
    let meta_list: UiMeta[] = [];

    for (const question of questions) {
      meta_list.push(new UiMeta(question, null, null));// (主體DATA, 上層問題, 上層選項)

      for (const option of question.Options ?? []) {
        meta_list.push(new UiMeta(option, question, null));// (主體DATA, 上層問題, 上層選項)

        for (const input of option.Inputs ?? []) {
          meta_list.push(new UiMeta(input, question, option));// (主體DATA, 上層問題, 上層選項)       
        }

      }
    }

    return meta_list;
  }



  FilterOptionMetas_ByQuestionGuid(question_guid: string): UiMeta[] {
    let option_metas = this.meta_rows.filter(x =>
      x.question_guid === question_guid
      && x.data_type === SpwkMetaData_DataType.Option
    );
    return option_metas;
  }

  FilterInputMetas_ByQuestionGuid(question_guid: string): UiMeta[] {
    let input_metas = this.meta_rows.filter(x =>
      x.question_guid === question_guid
      && x.data_type === SpwkMetaData_DataType.Input
    );
    return input_metas;
  }


  FilterInputMetas_ByOptionGuid(option_guid: string): UiMeta[] {
    let input_metas = this.meta_rows.filter(x =>
      x.option_guid === option_guid
      && x.data_type === SpwkMetaData_DataType.Input
    );
    return input_metas;
  }



  FindOptionByGuid(option_guid: string): UiMeta {
    let find_option_meta = this.meta_rows.filter(x =>
      x.option_guid === option_guid
      && x.data_type === SpwkMetaData_DataType.Option
    );

    if (find_option_meta.length === 1) {
      return find_option_meta[0];
    } else {
      throw new_ErrorAlert("4684641 預期應該剛好找到一個對應的選項 !!! " + find_option_meta.length);
    }
  }



  FindQuestionMeta_ByQuestionGuid(question_guid: string): UiMeta {
    let find_question_metas = this.meta_rows.filter(x =>
      x.question_guid === question_guid
      && x.data_type === SpwkMetaData_DataType.Question
    );

    if (find_question_metas.length === 1) {
      return find_question_metas[0];
    } else {
      throw new_ErrorAlert("1661584 預期應該剛好找到一個對應的題目 !!! " + find_question_metas.length);
    }
  }
}